<template>
    <div class="search-container w-100" v-click-outside="hideOptions">
        <div class="search">
            <i class="prz-search" id="search-icon"></i>
            <input 
                v-model="searchText"
                autocomplete="off" 
                type="text" 
                maxlength="50" 
                :placeholder="kStrings.kSEARCH_PLACEHOLDER" 
                data-sayt="1"
                @keyup="search"
                @keyup.enter="goToSearchPage()"
                @focus="isClub ? showOptions() : ''"
            />
            <i v-if="searchText && !isClub" @click="clearSearch()" class="prz-close" id="clear-search"></i>
        </div>
        <div v-if="showInfo && isClub" class="overlay" :style="{ top: getOverlayTopValue() + 'px' }" @click="hideOptions"></div>
        <div v-if="showInfo && isClub" class="search-options">
            <TermsList 
                v-if="recentSearches && !summaryData"
                :terms="recentSearches" 
                :title="kStrings.kRECENT_SEARCHES" 
                @termClicked="search"
                id="recent-search"
            />
            <TermsList 
                v-else-if="trendingSearches && !summaryData"
                :terms="trendingSearches" 
                :title="kStrings.kTRENDING_TODAY" 
                @termClicked="search"
                id="recent-search"
            />
            <Summary v-if="summaryData" 
                :isDesktop="true" 
                :results="summaryData"
                :txtSeeMore="kStrings.KSEE_MORE"
            />
            <div>
                <Loader v-if="recentSearches && isLoading" />
            </div>
        </div>
        <template v-if="catalogData">
            <Teleport to="#catalog-search">
                <Catalog  
                    :catalog-data="catalogData" 
                    :is-club="isClub" 
                />
            </Teleport>
        </template>
    </div>
</template>
<script>
import {debounce} from 'lodash-es';
import Summary from './Summary.vue';
import Teleport from 'vue2-teleport';
import TermsList from './TermsList.vue';
import httpRequest from '@/Utilities/httpRequest';
import { clickOutside } from '@/api/vueDirectives';
import Loader from '@/components/Muffin/Loader.vue';
import Catalog from '@/components/Catalog/Desktop/Index.vue';
import utilities from '@/Utilities/common';

export default {
    name: "SearchDesktop",
    components: {
        TermsList,
        Summary,
        Loader,
        Catalog,
        Teleport
    },
    props: {
        isClub: null,
        urlSearch: null,
        urlSearchSummary: null,
        inputVal: '',
        kStrings: {
            type:Object,
            default: undefined
        },
    },
    data() {
        return {
            isLoading: false,
            searchText: null,
            searchTextLast: null,
            showInfo: null,
            summaryData: null,
            recentSearches: null, 
            trendingSearches: null, 
            catalogData: null,
            location: null,
            pushedToHistory: false,
        };
    },
    mounted() {
        this.searchText     = this.inputVal;
        this.searchTextLast = this.inputVal;
        this.location       = window.location.href;
        window.addEventListener('popstate', this.onPopstate);
    },
    computed: {
        canSearch(){
            return this.searchText && this.searchText.length >= 2;
        }
    },
    methods: {
        // Show or Hide content div
        contentDisplay(show){
            const content = document.getElementById('content');
            if(show){
                this.catalogData = null;
                content.style.display = 'block';
            }else{
                content.style.display = 'none';
            }
        },
        showOptions(){
            this.$emit('searchFocus', true);
            this.showInfo = true;
            utilities.disableBodyScroll();
            if(this.isClub && this.canSearch){
                if(this.searchTextLast !== this.searchText){
                    this.search();
                }
            }
            else if(!this.recentSearches && !this.trendingSearches){
                this.getSearchResults(true);
            }
        },
        goToSearchPage(){
            if(this.canSearch){
                const element = document.getElementsByClassName("see-more")[0];
                if(element){
                    element.click();
                }
            }
        },
        hideOptions(){
            this.showInfo = false;
            this.$emit('searchFocus', false);
            utilities.enableBodyScroll();
        },
        search: debounce(function(text){
            if(text && typeof text === 'string'){
                this.searchText = text;
            }

            this.searchTextLast = this.searchText;
            if(this.isClub){
                this.showInfo = true;
                this.contentDisplay(true);
                if(this.canSearch){
                    this.getSearchSummary();
                }
                else{
                    this.summaryData = null;
                }
            }
            else{
                if(this.canSearch){
                    this.getSearchResults();
                    this.contentDisplay(false);
                    this.pushState(false, this.urlSearch);
                }else{
                    this.contentDisplay(true);
                }
            }
        }, 500),
        async getSearchSummary(){
            this.isLoading = true;
            const {data} = await httpRequest.get(this.urlSearchSummary, {text: this.searchText}, false);
            //console.log('Search desktop, search summary: ', data);
            if(data && data.hasOwnProperty('results')){
                this.summaryData = data.results.length ? data.results : null;
                if(data.suggestions){
                    this.hideOptions();
                    this.contentDisplay(false);
                    // format suggestions to send into component
                    this.catalogData = {
                        wsData:{
                            suggestions: data.suggestions
                        }   
                    }
                }
                else{
                    this.catalogData = null
                }
            }
            this.isLoading = false;
        },
        async getSearchResults(init){
            this.isLoading = true;
            const {data} = await httpRequest.get(this.urlSearch, {text: this.searchText}, false);
            if(init && data && data.hasOwnProperty('termsRecentlySearched')){
                this.recentSearches = data.termsRecentlySearched;
                this.trendingSearches = data.searchSuggestions;
            }
            else if(data && data.hasOwnProperty('catalogData')){
                // club is not active, show search results
                this.catalogData = data.catalogData;
            }
            this.isLoading = false;
        },
        clearSearch(){
            this.searchText = null;
            this.contentDisplay(true);
            this.catalogData = null;
            //this.pushState(true, this.location);
        },
        pushState(clearSearch, url){
            if(!clearSearch && window.location.port !== '8080'){
                const urlLocation = new URL(url);    
                urlLocation.searchParams.set('text', this.searchText);
                if(!this.pushedToHistory){
                    // add state to current URL history
                    history.replaceState({pushedFromSearch: true}, "", window.location);
                    // add new URL to history
                    history.pushState({}, "", urlLocation);
                    this.pushedToHistory = true;
                }else{
                    history.replaceState({}, "", urlLocation);
                }
            }
        },
        onPopstate(event){
            if(event.state && event.state.pushedFromSearch === true){
                window.location.reload();
            }
        },
        getOverlayTopValue(){
            const el = document.getElementById('header_search_bar');
            return (el.offsetTop > 0 ? document.getElementById('header').clientHeight : 0) + el.clientHeight;
        },
    },
};
</script>
<style lang="scss">
    @import "./Styles/Desktop/index.scss";
    @import "./Styles/index.scss";
</style>
